<template>
<div class="container">
  <div class="top">
    <div class="topLeft">
      <div class="picWord">图片新闻</div>
      <swiper
        :style="{ width: '100%', height: '100%' }"
        ref="mySwiper"
        :options="swiperOptions"
        v-if="picList.length"
      >
        <swiper-slide v-for="(item, i) in picList" :key="i">
          <div class="swiper-item">
            <div class="swiper-item-picture">
              <router-link :to="{path:'/bidsNew', query:{id:item.id,title:'图片新闻'}}">
               <img class="imgStyle" :src="url+item.relatedPictures" alt="" />
                <router-link :to="{path:'/bidsNew', query:{id:item.id,title:'图片新闻'}}"><div class="bottomWord">{{item.articleTitle}}</div></router-link>
              </router-link>
            </div>
<!--            <div class="swiper-item-describe">{{ item.describe }}</div>-->
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
<!--        <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--        <div class="swiper-button-next" slot="button-next"></div>-->
      </swiper>
      <!-- swiper两边按钮 -->
    </div>

      <div class="bodyAll">
       <ul>
         <li class="first1" @click="jump()"><a>首&nbsp;&nbsp;&nbsp;&nbsp;页</a></li>
         <li class="second2" @click="jumpS()"><a>集团概况</a></li>
         <li class="third" @click="jumpT()"><a>集团动态</a></li>
         <li class="fourth" @click="jumpF()"><a>党建之家</a></li>
         <li class="five" @click="jumpFI()"><a>企业文化</a></li>
         <li class="six" @click="jumpSI()"><a>联系我们</a></li>
       </ul>
     </div>
    <div class="topRignt">
        <div class="word">
           <div class="wordT">集团要闻</div>
        </div>
        <div class="list">
          <ul>
<!--            <li>测试测试<span>2022-2-22</span></li>-->
            <li v-for="(item,index) in listWord" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'集团要闻'}}"><a>{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>
          </ul>
        </div>
    </div>
  </div>

  <div class="middle">
      <div class="miLeft">
        <div class="WordM">
          <div  :class="isActive===0?'second':'first'" style="margin-right: 10px" @mouseenter="isActive=0">
            <div class="wordF">党务公开</div>
          </div>
          <div  :class="isActive===1?'second':'first'" @mouseenter="isActive=1">
            <div class="wordF">专题活动</div>
          </div>
        </div>

        <div class="first1" v-if="isActive===0">
          <div class="list">
            <ul>
              <li v-for="(item,index) in partyList" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'党务公开'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>
            </ul>
          </div>
        </div>
        <div class="second2" v-else-if="isActive===1">
          <div class="list">
            <ul>
              <li v-for="(item,index) in activList" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'专题活动'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="miRignt">
        <div class="word">
          <div class="wordT">通知公告</div>
        </div>
        <div class="listT">
          <ul>
            <li v-for="(item,index) in contactL" :key="index"><router-link :to="{path:'/bidsNew', query:{id:item.id,title:'通知公告'}}"><a href="/" target="_blank">{{item.articleTitle}}</a></router-link><span>{{item.releaseDate}}</span></li>
          </ul>
        </div>
      </div>
  </div>
  <div class="bases">
    <div class="basesLeft">
      <div class="word">
        <div class="wordT">集团成员</div>
      </div>
      <div class="menber">
        <div style="width: 33.3%;margin-left: 10px">
          <div class="company">临港建设</div>
          <img style="width: 100%;" src="../assets/one.jpeg">
        </div>
        <div style="width: 33.3%;margin-left: 10px">
          <div class="company">绿建公司</div>
          <img style="width: 100%;" src="../assets/two.jpeg">
        </div>
        <div style="width: 33.3%;margin-left: 10px;margin-right: 10px">
          <div class="company">智谷建设</div>
          <img style="width: 100%;" src="../assets/three.jpeg">
        </div>
      </div>
      <div class="menberT">
        <div style="width: 33.3%;margin-left: 10px;">
          <div class="company">希捷贸易</div>
          <img style="width: 100%;" src="../assets/four.jpeg">
        </div>
        <div style="width: 33.3%;margin-left: 10px;">
          <div class="company">都市良田</div>
          <img style="width: 100%;" src="../assets/five.png">
        </div>
        <div style="width: 33.3%;margin-left: 10px;margin-right: 10px">
        </div>
      </div>
    </div>
    <div class="basesRight">
      <div class="word">
        <div class="wordT">快捷导航</div>
      </div>
      <div class="mar">
        <div class="marT">
          <a href="http://www.yzltjt.com:89"><img src="../assets/logoT.png" class="imgSt"></a>
        </div>
        <div class="marT">
          <a href="http://www.yzltjt.com:84/LoginTwo"><img src="../assets/logo4.png" class="imgSt"></a>
        </div>
        <div class="marT">
          <router-link :to="{path:'/Relation'}">
            <a href="/"><img src="../assets/logo5.png" class="imgSt"></a>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css"
import $http  from '../ApI/request'  //$http是在导入时自定义的命名可变的
export default {
  name: 'Home',
  components: {  Swiper, SwiperSlide  },
  data () {
    return {
      isActive: 0,
      url: 'http://www.yzltjt.com/ri-richuang/sys/common/static/',
      listWord: [],
      contactL: [],
      partyList: [],
      activList: [],
      picList: [],
      swiperOptions: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        // loop: true,
    // effect: "cube",
        // cube: {
        //   slideShadows: true,
        //   shadow: true,
        //   shadowOffset: 100,
        //   shadowScale: 0.6,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          clickableClass : 'my-pagination-clickable',
          // progressbarOpposite: true,
        },
      },
    }
  },
  computed: {
    showSwiper(){
      return this.picList.length;
    }
  },
  mounted() {
    // new Swiper(".swiper-container", {
    //   direction: "horizontal", // 垂直切换选项
    //   //mousewheel: true, //滚轮
    //   autoplay: {
    //     //自动开始
    //     delay: 2500, //时间间隔
    //     disableOnInteraction: false, //*手动操作轮播图后不会暂停*
    //   },
    //   loop: true, // 循环模式选项
    //
    //   // 如果需要分页器
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true, // 分页器可以点击
    //   },
    //
    //   // 如果需要前进后退按钮
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //
    //   // 如果需要滚动条
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },
    // });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'图片新闻',
        column: 'releaseDate',
        order: 'asc'
      }
    }).then(res=>{
      this.picList = res.data.result.records.reverse()
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'集团要闻',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.listWord = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'通知公告',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.contactL = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'党务公开',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      this.partyList = res.data.result.records
    }).catch(e=>{
      console.log(e)
    });
  },
  created () {
    $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
      params:{
        articleType:'专题活动',
        column: 'releaseDate',
        order: 'desc'
      }
    }).then(res=>{
      console.log(res)
      this.activList = res.data.result.records
    })
  },
  methods:{
    jump(){
      this.$router.push({
        name:'HelloWorld',
      })
    },
    jumpS(){
      console.log(111)
      this.$router.push({
        name:'Survey',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('jdjd')
    },
    jumpT(){
      this.$router.push({
        name:'State',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('stjd')
    },
    jumpF(){
      this.$router.push({
        name:'Party',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('pajd')
    },
    jumpFI(){
      this.$router.push({
        name:'Culture',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('cujd')
    },
    jumpSI(){
      this.$router.push({
        name:'Relation',
        params:{
          num:1
        }
      });
      // localStorage.removeItem('rejd')
    },
    // tabs(){
    //   trs[i].onmouseover = function() {
    //     this.className = "bg"
    //   }
    //   this.className = "second"
    // }
    // skip(){
    //   console.log(111)
    //   this.$router.push({
    //     name:'Party',
    //   })
    // }
  }
}
</script>

<style scoped>

  .container{
    width: 75%;
    height: 100%;
    /*width: 1080px;*/
    margin:5px auto;
  }
  .bodyAll{
    display: none;
    /*width:100%;*/
    font-size: 28px;
    background-color: #ffffff;
    margin-top: 20px;
  }
  .bodyAll ul{
    list-style: none;
    zoom: 1;
    overflow: hidden;
    margin-left: -100px;
  }
  .bodyAll ul li{
    float: left;
    width: 25%;
  }
  .bodyAll ul li a{
    display: block;
    text-align: center;
    border-right: solid #EEEEEE 1px;
    border-bottom: solid #EEEEEE 1px;
    line-height: 120px;
  }
  .top{
    display: flex;
    justify-content: center;
    /*justify-content: space-evenly;*/
  }
  .topLeft,.topRignt{
    width: 45%;
    height: 300px;
    background-color: #ffffff;
    border: 1px solid #cce4c6;
  }
  .topLeft{
    position: relative;
  }
  .picWord{
    padding: 15px;
    font-size: 18px;
    position: absolute;
    z-index: 999;
    color: #ffffff;
    top: 0px;
    left: 0px;
    text-shadow: 1px 1px 8px #000;
  }
  .bottomWord{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: rgb(67, 67, 67);
    z-index: 9;
    line-height: 30px;
    font-weight: 700;
    font-size: 14px;
    padding: 0px 5px;
    text-align: left;
    height: 30px;
    color: rgb(255, 255, 255);
    opacity: 0.75;
    width: 543px;
  }
  .swiper-container{
    height: 340px;
  }
  /*.swiper-slide img{*/
  /*  width: 45%;*/
  /*}*/
  .imgStyle{
    width: 100%;
    height: 100%;
  }
  .word{
    width: 128px;
    margin-top: 12px;
    font-size: 16px;
    margin-bottom: -6px;
    height: 40px;
    margin-left: 20px;
    background-image: url("../assets/ty_nb.png");
  }
  .wordT{
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 2px;
    margin-left: 24px;
    color: white;
  }
  .list,.listT{
    font-size: 28px;
    overflow-y: auto;
    height: 240px;
  }
  .list ul,.listT ul{
    list-style-type: disc;
    /*list-style-position: inside;*/
    border-top: 1px solid #cce4c6;
  }
  .list ul li,.listT ul li{
    line-height: 34px;
    height: 34px;
    font-size: 14px;
    /*text-indent: 20px;*/
    /*position: relative;*/
  }
  .list ul li a{
    /*font-size: 17px;*/
    color: #333333;
    /*margin-left: -120px;*/
    margin-right: 20px;
    text-decoration:none;
    max-width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display:block;
    float:left;
    font-size: 14px;
  }
  .list ul li span,.listT ul li span{
    font-size: 14px;
    float: right;
    margin-right: 20px;
  }
  .middle,.bases{
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .bases{
    margin-bottom: 20px;
  }
  .miLeft,.basesLeft{
    width: 60%;
    height: 340px;
    background-color: #ffffff;
    border: 1px solid #cce4c6;
  }
  .miRignt{
    width: 28.5%;
    height: 340px;
    background-color: #ffffff;
    border: 1px solid #cce4c6;
    margin-left: 20px;
  }
  .basesRight{
    width: 28.5%;
    height: 340px;
    background-color: #ffffff;
    border: 1px solid #cce4c6;
    margin-left: 20px;
  }
  .first{
    width: 128px;
    height: 40px;
    color: #78a587;
    font-weight: 700;
    letter-spacing: 4px;
  }
  .second{
    color: #ffffff;
    font-weight: 700;
    letter-spacing: 4px;
    background-image: url("../assets/ty_nb.png");
    width: 128px;
    height: 40px;
    margin-right: 20px;
  }
  .WordM{
    display: flex;
    margin-left: 20px;
    margin-top: 15px;
    cursor: pointer
  }
  .wordF{
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 2px;
    margin-left: 24px;
  }
  .listT ul li a{
    /*font-size: 17px;*/
    color: #333333;
    /*margin-left: -120px;*/
    margin-right: 20px;
    text-decoration:none;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display:block;
    float:left;
  }
  .menber{
    display: flex;
    margin-top: 10px;
    justify-content: space-evenly;
  }
  .menberT{
    display: flex;
    margin-top: 10px;
    justify-content: space-evenly;
  }
  .company{
    color: #215531;
    font-size: 16px;
    text-align: left;
  }
  .mar{
    border-top: 1px solid #cce4c6;
    margin-top: 15px;
    text-align: center;
  }
  .marT{
    margin-top: 10px;
  }
  .imgSt{
    width: 327px;
    height: 47px
  }
  @media screen and (max-width: 750px) {
    /* 移动端的CSS样式代码 */
    .container{
      width: 100%;
      /*width: 1080px;*/
      margin:5px auto;
    }
    .picWord{
      font-size: 28px;
    }
    .bodyAll{
      display: block;
    }
    .top{
      display: block;
    }
    .topLeft{
      width: 100%;
      height: 800px;
      position: relative;
    }
    .topRignt{
      width: 100%;
      height: 600px;
      margin-top: 15px;
      overflow-y: auto;
    }
    .middle,.bases{
      display: block;
      margin-top: 10px;
    }
    .bottomWord{
      line-height: 40px;
      font-size: 28px;
      height: 40px;
      width: 100%;
    }
    .word{
      background: url(../assets/ty_nb.png) no-repeat;
      width: 20%;
      height: 60px;
      /*margin: 5px auto;*/
      background-size: cover;
      position: relative;
    }
    .wordT{
      /*padding: 15px;*/
      font-size: 32px;
      position: absolute;
      color: #fff;
      top: 10px;
      left: 100px;
    }
    /*.list ul li span{*/
    /*  display: none;*/
    /*}*/
    .miLeft{
      width: 100%;
      height: 500px;
      margin-top: 10px;
    }
    .miRignt{
      width: 100%;
      height: 500px;
      margin-left: 0;
      margin-top: 10px;
    }
    .first{
      /*width: 128px;*/
      /*height: 40px;*/
      width: 30%;
      height: 60px;
      color: #78a587;
      font-weight: 700;
      letter-spacing: 4px;
    }
    .second{
      background: url("../assets/ty_nb.png") no-repeat;
      width: 20%;
      height: 60px;
      /* margin: 5px auto; */
      background-size: cover;
      position: relative;
    }
    .wordF{
      margin-top: 10px;
      font-size: 32px;
    }
    .list ul,.listT ul{
      margin-left: -40px;
    }
    .list ul li,.listT ul li {
      /*list-style: none;*/
      height: 70px;
      font-size: 28px;
      line-height: 70px;
    }
    .list ul li a{
      max-width: 540px;
      font-size: 28px;
    }
    .listT ul li a{
      max-width: 540px;
    }
    .list ul li span{
      font-size: 28px;
    }
    .listT ul li span{
      font-size: 28px;
    }
    .basesLeft{
      width: 100%;
      height: 700px;
    }
    .basesRight{
      width: 100%;
      height: 300px;
      margin-left: 0px;
      margin-top: 50px;
    }
    .mar{
      display: flex;
      margin-left: 50px;
    }
    .marT{
      margin-left: 50px;
      margin-top: -50px;
    }
    .imgSt{
      width: 460px;
      height: 47px
    }
  }
</style>
<style>
.swiper-pagination-bullet{
  width: 6px !important;
  height: 6px !important;
  background-color: #FFFFFF !important;
  opacity: 0.75 !important;
  /*float: right !important;*/
}
.swiper-pagination-bullet-active{
  width: 14px !important;
  height: 6px !important;
  border-radius: 3px !important;
  opacity: 1 !important;
  background-color: #FFFFFF !important;
}
.my-pagination-clickable{
  text-align: right !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue